import { Check, Checks, Clock } from "@phosphor-icons/react";

import { cn } from "../utils/cn";

type DeliveryState = "pending" | "sent" | "delivered" | "read";

interface DeliveryIndicatorProps {
  state: DeliveryState;
  label: string;
  className?: string;
}

export function DeliveryIndicator({ state, label, className }: DeliveryIndicatorProps) {
  const icon = (() => {
    switch (state) {
      case "pending":
        return <Clock size={14} weight="bold" />;
      case "sent":
        return <Check size={14} weight="bold" />;
      case "delivered":
      case "read":
        return <Checks size={14} weight="bold" />;
      default:
        return null;
    }
  })();

  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5",
        state === "read"
          ? "text-sky-500 dark:text-sky-400"
          : "text-slate-400 dark:text-slate-500",
        className
      )}
      aria-label={label}
      title={label}
    >
      {icon}
      <span className="sr-only">{label}</span>
    </span>
  );
}
